import styled from "styled-components";

import { PopoverContent } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

/** PopoverContent defaults to z-index 1000; NoTouchPurchaseModal uses 1080 — keep paid-excel below NoTouchPurchaseModal. */
export const PaidExcelPopoverContent = styled(PopoverContent)`
    z-index: 1000;
`;

export const DownloadButtonWrapper = styled(FlexRow)`
    position: relative;
    align-items: center;
    left: 7px;

    .ranking-history & {
        bottom: 3px;
    }
    .widget-KeywordsGraph & {
        bottom: 15px;
        right: 6px;
        left: inherit;
    }
    .sw-pie-chart &,
    .sw-chart-inner & {
        position: absolute;
        top: 8px;
        right: 12px;
        bottom: initial;
        left: initial;
    }
    .sw-section-destination-paidoutgoing & {
        right: 44px;
    }
`;

export const ExportButtonsContainer = styled.div`
    display: inline-flex;
    flex-direction: row-reverse;
    margin-right: 4px;
`;

export const UpsellPopupWrapper = styled.div`
    padding: 15px;
    width: 250px;
    text-align: center;
`;

export const UpsellPopupText = styled.div`
    margin-bottom: 20px;
`;
